import { useBeforeUnload, useLocation } from "@remix-run/react";
import { useEffect, useRef } from "react";

export default function useTrackNavigation(
  onNavigateAway?: (fromRoute: string, toRoute: string) => void
) {
  const location = useLocation();
  const previousLocation = useRef(location.pathname);

  useEffect(() => {
    const prevPath = previousLocation.current;
    const currentPath = location.pathname;

    if (prevPath !== currentPath) {
      // This runs AFTER navigation has completed
      // Pass the route they LEFT FROM and where they went TO
      onNavigateAway?.(prevPath, currentPath);
      previousLocation.current = currentPath;
    }
  }, [location.pathname, onNavigateAway]);

  // Handle browser navigation - only know the FROM route
  useBeforeUnload(() => {
    onNavigateAway?.(location.pathname, "external");
  });
}
